import hive from '@hiveio/hive-js';
import { HIVE_API } from '../config';
import { callChainBridge, getChainAccount } from './chainActions';

hive.api.setOptions({ url: HIVE_API });

export const getAccount = username => {
  return getChainAccount(hive, username);
};

export const callBridge = (method, params) => {
  return callChainBridge(hive, method, params);
};

export default hive;
